/*
 * Copyright (c) 2024 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import { Pipe, PipeTransform } from '@angular/core';


@Pipe({
    name: 'px',
    standalone: false
})
export class PixelConverter implements PipeTransform {
  transform(value: string | number, args: string[]): any {
    if (value === undefined) {
        return;
    }
    if (typeof value === 'string') {
        return value;
    }
    if (typeof value === 'number') {
        return value + 'px';
    }
  }
}
